























import { Component, Vue } from 'vue-property-decorator'
import { Route } from '@/model/Routes'

@Component({
  components: {
    
  },
})
export default class Home extends Vue {
  private items: Route[] = [];

  mounted(): void  {
    this.$router.options.routes?.forEach(route => {
      this.items.push({
        name: route.name,
        path: route.path
      })
    })
  }
}
